import { useMutation } from '@tanstack/react-query';
import { updateUserTodoSortMode } from 'shared/services/backend-api';
import { SortingMode } from 'shared/types/sorting-mode';

export const useUpdateTodoSortModeMutation = () =>
  useMutation({
    mutationFn: async (sortMode: SortingMode) =>
      updateUserTodoSortMode(sortMode),
  });
